import * as Sentry from '@sentry/node'
import { Integrations } from '@sentry/tracing'

class SentryHelper {
    initSentry() {
        const sentryDSN = process.env.SENTRY_DSN || ''
        const isClient = typeof window !== 'undefined'
        if (isClient) {
            Sentry.init({
                dsn: sentryDSN,
                integrations: [new Integrations.BrowserTracing()],
                tracesSampleRate: 1.0
            })
        } else {
            Sentry.init({
                dsn: sentryDSN,
                tracesSampleRate: 1.0
            })
        }
    }
}

export default new SentryHelper()
